import {Component, OnInit} from '@angular/core';
import {
  CartegraphConfiguration,
  CartegraphFeature,
  CartegraphFeatureFlag,
  CartegraphObservationSettings,
  CartegraphShiftTaskDefault,
  CartegraphTaskDefault,
  CartegraphTaskDefaults
} from '../../../../../shared/models/cartegraph.model';
import {CartegraphManagementService} from '../../../../../data/cartegraph/cartegraph-management.service';
import {Router, RouterOutlet} from '@angular/router';
import {CartegraphSettingsObservationsComponent} from '../cartegraph-observations/cartegraph-settings-observations.component';
import {MatDivider} from '@angular/material/list';
import {
  CartegraphSettingsDefaultsObservationComponent
} from '../cartegraph-defaults/cartegraph-settings-defaults-observation.component';
import {CartegraphSettingsDefaultsShiftComponent} from '../cartegraph-defaults/cartegraph-settings-defaults-shift.component';
import {RowWithToggleComponent} from '../../row-with-toggle/row-with-toggle.component';
import {FormsModule} from '@angular/forms';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'app-cartegraph-settings-features',
  template: '<router-outlet></router-outlet>',
  imports: [
    RouterOutlet
  ],
  standalone: true
})
export class CartegraphSettingsFeaturesMainComponent {
}
